import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../common/page/base.component';
import { LocaleService } from '../../common/locale/locale.service';
import { TranslationMapperService } from '../../common/translation-mapper.service';

@Component({
    selector: 'u-dotcom-modal',
    templateUrl: './dotcom-modal.component.html',
    styleUrls: ['./dotcom-modal.component.scss'],
    standalone: false,
})
export class DotcomModalComponent extends BaseComponent {
    @Input() src: string;

    map = {
        heading: 'heading',
        text: 'text',
    };

    constructor(
        protected http: HttpClient,
        localeService: LocaleService,
        titleService: Title,
        metaService: Meta,
        translationMapperService: TranslationMapperService,
        el: ElementRef,
        private readonly modalService: NgbModal,
    ) {
        super(http, localeService, titleService, metaService, translationMapperService, el);
    }

    close(): void {
        this.modalService.dismissAll();
    }
}
